import {
  CKBadge,
  CKBox,
  CKButton,
  CKCompanyLogo,
  CKIconBox,
  CKLayoutGrid,
  CKLayoutHorizontal,
} from 'clearkit';

import { CompanyType } from './types';

type companyCardProps = {
  company: CompanyType;
  onAddHubSpot: () => void;
};

export const CompanyCard = ({ onAddHubSpot, company }: companyCardProps) => {
  const dividerClasses = 'pt-4 border-t border-gray-200';
  const showAddToHubSpot = false;
  const hasTags = company.tags.length;

  return (
    <CKBox className="p-6">
      <CKLayoutGrid
        className="grow"
        gridTemplateRows={hasTags ? 'auto 1fr auto' : '1fr auto'}
      >
        <header className="space-y-4">
          <CKLayoutHorizontal justifyContent="center">
            <CKIconBox className="!p-0.5">
              <CKCompanyLogo domain={company.domain ?? ''} size={48} />
            </CKIconBox>
          </CKLayoutHorizontal>
          <div className="text-sm text-center">
            <h3 className="text-lg font-medium">{company.name}</h3>
            <h4>{company.domain}</h4>
          </div>
        </header>
        {hasTags ? (
          <CKLayoutHorizontal
            alignItems="start"
            className={dividerClasses}
            gap=".5rem"
            justifyContent="center"
          >
            {company.tags.map((tag) => (
              <CKBadge key={tag}>{tag}</CKBadge>
            ))}
          </CKLayoutHorizontal>
        ) : null}
        <CKLayoutHorizontal className={dividerClasses} justifyContent="center">
          <CKButton
            isDisabled={!showAddToHubSpot}
            onClick={onAddHubSpot}
            variant="simple"
            variantColor="blue"
          >
            Add to HubSpot
          </CKButton>
        </CKLayoutHorizontal>
      </CKLayoutGrid>
    </CKBox>
  );
};
